import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { SellerConnectService } from './seller-connect.service';
import { ConfigService } from '../config/config.service';
export class SellerConnectComponent implements OnInit {
private sellerConnectService: SellerConnectService;
public config: any;
public stripe_client_id: String;
private authorizationCode: string;
private authorizationError: number;
private authorizationErrorDescription: string;
private authorizationScope: string;
/**
 * @param {?} sellerConnectService
 * @param {?} configService
 * @param {?} router
 */
constructor(
        sellerConnectService: SellerConnectService,
private configService: ConfigService,
private router: Router
    ) {
        // Do stuff
        this.router.routerState.root.queryParams.subscribe((data) => {
            this.authorizationCode = data['code'];
            this.authorizationScope = data['scope'];
            this.authorizationError = data['error'];
            this.authorizationErrorDescription = data['error_description'];
        });

        this.configService.getConfig((configuration: any) => {
            this.config = configuration;
            this.stripe_client_id = this.config.stripe_client_id;
        });

        this.sellerConnectService = sellerConnectService;
    }
/**
 * @return {?}
 */
ngOnInit() {
        console.log('Hello Seller Connect');
    }
/**
 * @return {?}
 */
connectSeller() {
        this.sellerConnectService.connectSeller().subscribe(
            (next) => {
                console.log('sellerConnect.next next = ' + next);
            },
            (err) => {
                console.log('connectSeller.err err = ' + err);
            },
            () => {
                console.log('connectSeller.completed');
            });
    }
/**
 * @return {?}
 */
completeAuthorization(): void {

        this.sellerConnectService.getConnectToken(this.authorizationCode).subscribe(
            (next) => {
                console.log('home.component.ts: HomeComponent.ngOnInit(): getConnectToken next = ');
                console.log(next);
            },
            (err) => {
                console.log('home.component.ts: HomeComponent.ngOnInit(): getConnectToken err = ');
                console.log(err);
                alert('home.component.ts: HomeComponent.ngOnInit(): getConnectToken err = ' + err);
            },
            () => {
                console.log('home.component.ts: HomeComponent.ngOnInit(): getConnectToken completed');
            }
        );
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'my-seller-connect',
    template: "<p> Connect your seller account to the 22ndTech platform! </p> <br/> <br/> <a href=\"{{'https://connect.stripe.com/oauth/authorize?response_type=code&amp;client_id=' + stripe_client_id + '&amp;scope=read_write'}}\" class=\"connect-button\"><span>Connect with Stripe</span></a> <br/> <button *ngIf=\"authorizationCode\" (click)=\"completeAuthorization()\">Complete Authorization</button> ",
    styles: [""]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: SellerConnectService, },
{type: ConfigService, },
{type: Router, },
];
}

function SellerConnectComponent_tsickle_Closure_declarations() {
/** @type {?} */
SellerConnectComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
SellerConnectComponent.ctorParameters;
/** @type {?} */
SellerConnectComponent.prototype.sellerConnectService;
/** @type {?} */
SellerConnectComponent.prototype.config;
/** @type {?} */
SellerConnectComponent.prototype.stripe_client_id;
/** @type {?} */
SellerConnectComponent.prototype.authorizationCode;
/** @type {?} */
SellerConnectComponent.prototype.authorizationError;
/** @type {?} */
SellerConnectComponent.prototype.authorizationErrorDescription;
/** @type {?} */
SellerConnectComponent.prototype.authorizationScope;
/** @type {?} */
SellerConnectComponent.prototype.configService;
/** @type {?} */
SellerConnectComponent.prototype.router;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
